<template>
  <div id="app" :class="mobile?'mobile':''">
    <dcHeader v-if="!mobile"></dcHeader>
    <div class="head-box" v-if="mobile">
      <span @click="goBack()"></span>
      <div>DC收银台</div>
    </div>
    <router-view/>
    <dcFooter v-if="!mobile"></dcFooter>
  </div>
</template>

<script>
  import dcFooter from './components/footer'
  import dcHeader from './components/header'
  export default {
      components:{
          dcFooter,
          dcHeader,
      },
      name: 'APP',
      data () {
          return {
              width:'',
              mobile:false,
          }

      },
      methods: {
          goBack(){
              this.$router.go(-1);
          }
      },
      mounted(){
          this.width = document.body.clientWidth;
          if(this.width>750){
              this.mobile = false;
          }else{
              this.mobile = true;
          }
      }
  }
</script>
<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background: #F5F6F7;
  height: 100vh;
}
body{
  margin-top: 0;
}
.mobile{
  padding-top:0!important;
}
.head-box {
  width: 100%;
  height: 0.88rem;
  line-height: 0.88rem;
  background: #39393D;
  position: fixed;
  z-index: 5000;
  display: flex;
  justify-content: space-around;

span{
  position: absolute;
  top:0.26rem;
  left: 0.3rem;
  width: 0.22rem;
  height: 0.4rem;
  background: url("./assets/img/mobile/backArrow.png") no-repeat 0 0;
  background-size: cover;
}
div {
  font-size: 0.36rem;
  margin: 0 auto;
  text-align: center;
  color: rgba(255,255,255,1);;
}
}
</style>
